<template>
  <b-container>
    <b-row class="mt-2 mb-2">
      <b-col>
        <hr size=1 style="background-color:#CCC;">
      </b-col>
    </b-row>
    <b-row align-h="center">
      <b-col cols="12" class="text-center">
        <b-link to="/home"><img src="@/art/logo.png" class="fluid" style="max-width:180px;" /></b-link>
      </b-col>
    </b-row>
    <b-row class="mb-3">
      <b-col class="text-center">
        &copy; {{(new Date).getFullYear()}}  Viva Learning LLC
        <div>All rights reserved.</div>
      </b-col>
    </b-row>
    <!-- <b-row class="mt-3 mb-3">
      <b-col class="text-center">
        <b-link to="/privacy">Privacy Policy</b-link>
        &nbsp;&nbsp;&bull;&nbsp;&nbsp;
        <b-link to="/terms">Terms &amp; Conditions</b-link>
      </b-col>
    </b-row> -->
    <!-- <b-row class="mt-3 mb-3">
      <b-col class="text-center">
        Version: {{version}}
        &nbsp;&nbsp;&bull;&nbsp;&nbsp;
        Build: {{build}}
      </b-col>
    </b-row> -->
  </b-container>
</template>
<script>
/* eslint-disable */
// import router from "../router"

var data = {
  debug: false
 };

export default {
  name: "FooterBar",
  data() {
    return data;
  },
  computed: {
    isLoggedIn() { 
      return this.$root.hasToken() 
    },
    token() {
      return this.$root.getToken()
    },
    version() { return this.$root.getVersion() },
    build() { return this.$root.getBuild() }
  },
  methods: {},
  mounted() {}
};
</script>

<style scoped>
.menu-links a {
  display: inline-block;
  text-decoration: none;
  color: #fff;
}

.nav-item-left {
  text-align: left;
}

.nav-item-right {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/FooterBar.vue